import React, { useRef, useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  TextField,
  Button,
  IconButton,
  useMediaQuery 
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch } from "react-redux"; // For dispatching actions


const ClassSummaryModal = ({ open, handleClose, onMissed, onDelivered}) => {
    const isMobile = useMediaQuery("(max-width:635px)");
    const Dispatch = useDispatch();
    const [classSummaryFeedbackReason, setClassSummaryFeedbackReason] = useState(""); // Track selected radio button
    const [classSummaryFeedback, setClassSummaryFeedback] = useState(""); // Track textarea input

    // Determine if the button should be disabled
    const isButtonDisabled = classSummaryFeedbackReason === "" || 
    (classSummaryFeedbackReason === "Other/Explain reason" && classSummaryFeedback.trim() === "");

    // Function to get the feedback text based on selected options
    const getClassFeedback = () => {
        if (classSummaryFeedbackReason === "Other/Explain reason") {
            return classSummaryFeedback; // Return the text area value if "Other" is selected
        }
        return classSummaryFeedbackReason; // Return the selected reason
    };


  return (
    <Dialog open={open} aria-labelledby="dialog-title"
    PaperProps={{
        style: {
          width: isMobile ? "98%" : "25%", // Change width to 80% for mobile screens, 35% otherwise
          borderRadius: "19px", // Border radius of 20px
          paddingInline: isMobile ? "5px" : "",
        },
      }}>
      <DialogTitle
        id="dialog-title"
        className="w-full flex justify-center relative"
        style={{ textAlign: "center", marginBottom: "0px" }} // Center the title text
      >
        <span className="text-center mt-[10px] font-bold">Class Summary</span>
        <IconButton
          onClick={handleClose}
          size="small"
          // sx={{ backgroundColor: "transparent" }}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            backgroundColor: "transparent",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      
        <DialogContent style={{ marginTop: "-10px" }}>
        <Typography className="text-center mt-[-10px]">
                 Please provide a short summary of this class
          </Typography>
         
           {/* Radio buttons for selection */}
            <div className="w-full flex flex-col mt-4">
              <label className="mb-2 text-[16px] lg:text-[18px] text-[#464646]" >
                <input
                  type="radio"
                  value="The class ended up successfully."
                  checked={classSummaryFeedbackReason === "The class ended up successfully."}
                  onChange={(e) => setClassSummaryFeedbackReason(e.target.value)}
                  className="mr-[10px]"
                />
                The class ended up successfully.
              </label>
              <label className="mb-2 text-[16px] lg:text-[18px] text-[#464646]">
                <input
                  type="radio"
                  value="The class was not completed."
                  checked={classSummaryFeedbackReason === "The class was not completed."}
                  onChange={(e) => setClassSummaryFeedbackReason(e.target.value)}
                  className="mr-[10px]"
                />
                The class was not completed.
              </label>

              <label className="mb-2 text-[16px] lg:text-[18px] text-[#464646]">
                <input
                  type="radio"
                  value="Got an issue with the vehicle."
                  checked={classSummaryFeedbackReason === "Got an issue with the vehicle."}
                  onChange={(e) => setClassSummaryFeedbackReason(e.target.value)}
                  className="mr-[10px]"
                />
                Got an issue with the vehicle.
              </label>

              <label className="mb-2 text-[16px] lg:text-[18px] text-[#464646]">
                <input
                  type="radio"
                  value="Student left the vehicle early."
                  checked={classSummaryFeedbackReason === "Student left the vehicle early."}
                  onChange={(e) => setClassSummaryFeedbackReason(e.target.value)}
                  className="mr-[10px]"
                />
                Student left the vehicle early.
              </label>

              <label className="mb-2 text-[16px] lg:text-[18px] text-[#464646]">
                <input
                  type="radio"
                  value="Other/Explain reason"
                  checked={classSummaryFeedbackReason === "Other/Explain reason"}
                  onChange={(e) => setClassSummaryFeedbackReason(e.target.value)}
                  className="mr-[10px]"
                />
                Other/Explain reason
              </label>
            </div>

            {/* Conditionally show textarea if "Other" is selected */}
            {classSummaryFeedbackReason === "Other/Explain reason" && (
              <div className="w-full flex justify-center items-center">
                <textarea
                  className="mt-4 h-24 w-[95%] lg:w-[90%] resize-none rounded-md border-2 border-[#4C34AD] p-2 focus:outline-none"
                  placeholder="Please provide additional details."
                  value={classSummaryFeedback}
                  onChange={(e) => setClassSummaryFeedback(e.target.value)}
                />
              </div>
            )}
        </DialogContent>
        <DialogActions>
          <div className="flex gap-[10px] lg:gap-[15px] w-full justify-center pb-5">
          <button
              className="w-[120px] lg:w-[150px] h-[35px] lg:h-[40px] rounded-[12px] text-[16px] lg:text-[20px]"
              style={{ border: "1px solid #B5AAFF" }}
              onClick={() => onMissed(getClassFeedback())} // Pass feedback to onMissed
              disabled={isButtonDisabled} 
            >
              Missed
            </button>

            <button
              className="w-[120px] lg:w-[150px] h-[35px] lg:h-[40px] rounded-[12px] text-[16px] lg:text-[20px] text-[#FFFFFF] bg-[#B5AAFF]"
              onClick={() => onDelivered(getClassFeedback())} // Pass feedback to onDelivered
              disabled={isButtonDisabled} // Disable the button based on condition
            >
            Delivered
            </button>

          </div>
        </DialogActions>
    </Dialog>
  );
};

export default ClassSummaryModal;
